(() => {
  const ROOT_SELECTOR = '[data-lp]';
  const STICKY_SELECTOR = '[data-lp-sticky]';

  function setBodyOffset() {
    const hasSticky = Boolean(document.querySelector(`${ROOT_SELECTOR}[data-sticky-enabled="true"] ${STICKY_SELECTOR}`));
    document.body.classList.toggle('lp-sticky-active', hasSticky);
  }

  function initSticky(root) {
    if (!root || root.dataset.stickyEnabled !== 'true' || root.dataset.stickyReady === 'true') return;

    const stickyBar = root.querySelector(STICKY_SELECTOR);
    if (!stickyBar) return;

    const threshold = Number.parseInt(root.dataset.stickyOffset || '400', 10);

    const updateSticky = () => {
      stickyBar.classList.toggle('is-visible', window.scrollY > threshold);
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    root.dataset.stickyReady = 'true';
    root._lpCleanup = () => {
      window.removeEventListener('scroll', updateSticky);
      window.removeEventListener('resize', updateSticky);
    };

    updateSticky();
    setBodyOffset();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initSticky);
    setBodyOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (typeof root._lpCleanup === 'function') root._lpCleanup();
    });
    setBodyOffset();
  });
})();
